import { render } from "./page.vue?vue&type=template&id=5eee2751&scoped=true&ts=true"
import script from "./page.vue?vue&type=script&lang=ts"
export * from "./page.vue?vue&type=script&lang=ts"

import "./page.vue?vue&type=style&index=0&id=5eee2751&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/mysystem_data_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5eee2751"]])

export default __exports__